import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LaQualitaDegliIngredienti() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const ingredients = [{
    title: "Pistacchio di Bronte",
    description: "L'oro verde di Sicilia, coltivato alle pendici dell'Etna. Un gusto intenso e un colore smeraldo inconfondibile che rende unici i nostri dolci.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/bronte_pistachio_macro.png",
    alt: "Macro shot di pistacchi di Bronte sgusciati"
  }, {
    title: "Mandorle Siciliane",
    description: "Mandorle di Avola selezionate, dolci e aromatiche. La base perfetta per la nostra pasta reale e i dolci di marzapane.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/sicilian_almonds_macro.png",
    alt: "Dettaglio di mandorle siciliane fresche"
  }, {
    title: "Ricotta di Pecora",
    description: "Freschissima, proveniente da allevamenti locali selezionati. Setacciata ogni mattina per garantire una cremosità e una dolcezza uniche.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/sheep_ricotta_macro.png",
    alt: "Ricotta di pecora fresca in primo piano"
  }, {
    title: "Farine Locali",
    description: "Grani antichi siciliani macinati a pietra. Un ingrediente povero che diventa ricchezza, donando profumo di tradizione e consistenza rustica.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/local_flour_macro.png",
    alt: "Mucchio di farina di grani antichi siciliani"
  }];
  return <section id="la-qualità-degli-ingredienti" ref={ref} className={cn("bg-background py-16 md:py-24 transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-serif text-3xl font-bold text-primary md:text-4xl lg:text-5xl">
            La Qualità degli Ingredienti
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground font-sans text-lg">
            Il segreto della nostra pasticceria risiede nella selezione rigorosa delle materie prime. 
            Solo il meglio della terra siciliana entra nel nostro laboratorio.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {ingredients.map((item, i) => <Card key={i} data-index={i} className="group overflow-hidden border-none bg-card shadow-md transition-all hover:-translate-y-1 hover:shadow-xl">
              <div className="relative aspect-square overflow-hidden">
                <img src={item.image} alt={item.alt} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </div>
              
              <CardHeader className="pb-2 text-center">
                <CardTitle className="font-serif text-xl text-chart-2">
                  {item.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="text-center">
                <CardDescription className="text-muted-foreground font-sans leading-relaxed">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}